/**
 * Subdomain-based PWA scope helper.
 *
 * The Driver portal is deployed on a dedicated subdomain (e.g.
 * `driver.mrpco.net`) so iOS / Android treat it as a fully isolated PWA
 * origin. This lets the customer storefront and driver app coexist on the
 * same device — neither blocks the other's install prompt the way they
 * did when both lived under `/` and `/driver` on the same origin.
 *
 * The same React bundle serves BOTH origins; this module is the single
 * source of truth for "which app am I serving right now?"
 *
 * Detection rule: hostname starts with `driver.` (case-insensitive).
 *
 * Why hostname-only (not REACT_APP_DRIVER_HOST env): the bundle is the
 * same in production for both origins — we can't bake a hostname into
 * the build without producing two separate bundles. Runtime check it is.
 */
export const isDriverHost = () => {
  if (typeof window === 'undefined' || !window.location) return false;
  const h = (window.location.hostname || '').toLowerCase();
  return h.startsWith('driver.');
};

/**
 * "Are we in driver context?" — true if either the hostname is the
 * driver subdomain OR the current path is `/driver/*`. Most UI code
 * should use this; the manifest / install logic should use the
 * hostname-only check above so the driver-subdomain manifest is served
 * for every page on that origin.
 */
export const isDriverContext = (pathname) => {
  if (isDriverHost()) return true;
  if (typeof pathname !== 'string') return false;
  return pathname.startsWith('/driver');
};
